import { DeleteOutlined } from "@ant-design/icons";
import { Button, Col, Form, Modal, Row, Space, Table } from "antd";
import holidayApi from "api/holiday";
import { DatePicker } from "components/";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function ModalHoliday({ openNotificationWithIcon, getShopByRole }) {
    const [formAdd] = Form.useForm()

    const [openModal, setOpenModal] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    const [listHoliday, setListHoliday] = useState([])
    const [selected, setSelected] = useState('')

    const { t } = useTranslation()

    const addHoliday = async (values) => {
        try {
            await holidayApi.createHoliday(values);
            formAdd.resetFields();
            fetchHoliday()
            getShopByRole()
            openNotificationWithIcon("success", t('notification'), t('createHolidaySuccess'));
        } catch (error) {
            openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
        }
    }

    const deleteHoliday = async () => {
        try {
            await holidayApi.deleteHoliday(selected);
            onCloseDelete()
            fetchHoliday()
            getShopByRole()
            openNotificationWithIcon("success", t('notification'), t('deleteHolidaySuccess'));
        } catch (error) {
            openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
        }
    }

    const fetchHoliday = async () => {
        const { holidays } = await holidayApi.getAll()
        setListHoliday(holidays)
    }

    const onOpenDelete = (id) => {
        setSelected(id)
        setOpenDelete(true)
    }

    const onCloseDelete = () => {
        setSelected('')
        setOpenDelete(false)
    }

    const columns = [
        {
            key: 'date',
            dataIndex: 'date',
            title: t('holiday'),
            render: (_) => moment(_).format('YYYY-MM-DD')
        },
        {
            key: 'action',
            dataIndex: 'action',
            title: t('action'),
            render: (_, record) => (
                <Button danger onClick={() => onOpenDelete(record._id)} icon={<DeleteOutlined />} />
            )
        },
    ]

    useEffect(() => {

        fetchHoliday()
    }, [])

    return (
        <>
            <Button type='primary' size='large' onClick={() => setOpenModal(true)}>
                {t('holidayManage')}
            </Button>
            <Modal
                title={t('holidayManage')}
                onCancel={() => setOpenModal(false)}
                open={openModal}
                footer=''
            >
                <Form form={formAdd} onFinish={addHoliday}>
                    <Form.Item label={t('holiday')} name='date' rules={[{ required: true, message: t('required') }]}>
                        <DatePicker format='YYYY-MM-DD' placeholder='' />
                    </Form.Item>
                    <Form.Item>
                        <Button htmlType='submit' type='primary'>
                            {t('createHoliday')}
                        </Button>
                    </Form.Item>
                </Form>
                <Table columns={columns} dataSource={listHoliday} />
            </Modal>
            <Modal
                title={t('deleteHoliday')}
                onCancel={onCloseDelete}
                open={openDelete}
                footer=''
            >
                <h2 style={{ color: 'red' }}>{t('sureToDelete')}</h2>
                <Space>
                    <Button danger onClick={deleteHoliday}>
                        Ok
                    </Button>
                    <Button onClick={onCloseDelete}>
                        {t('cancel')}
                    </Button>
                </Space>
            </Modal>
        </>
    )
}
